import { Injectable, Injector } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';

import { License } from '..';
import { HttpDataService } from './http-data.service';
import { JobsService } from './jobs.service';

@Injectable()
export class LicensesService extends HttpDataService {
  constructor(protected injector: Injector, private jobsService: JobsService) {
    super(injector, '/core/licenses');
  }

  getLicense(id: string): Observable<License> {
    return super.getItem(id);
  }

  createLicensesFromCsv(file: File, groupId: string, hasToReEnroll: boolean): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return lastValueFrom(
      this.http.post(
        `${this.baseUrl}/${groupId}/batch${hasToReEnroll ? '?hasToReEnroll=true' : '?hasToReEnroll=false'}`,
        formData
      )
    )
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }

  createLicensesBatch(studentsList: any[], groupId: string, hasToReEnroll: boolean): Promise<any> {
    return lastValueFrom(
      this.http.post(
        `${this.baseUrl}/${groupId}/batch${hasToReEnroll ? '?hasToReEnroll=true' : '?hasToReEnroll=false'}`,
        {
          studentsList
        }
      )
    )
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }

  createLicenses(licenses: any[], groupId: string): Promise<any> {
    const url = `${this.baseUrl}/${groupId}`;
    return super.postRequest(url, JSON.stringify(licenses), this.getRequestOptions());
  }

  updateStatus(id: string, status: string) {
    const url = `${this.baseUrl}/${id}/status`;
    return super.putRequest(url, { status }, this.getRequestOptions());
  }

  forceLicenseCompletion(licenseId: string) {
    const url = `${this.baseUrl}/${licenseId}/status/completed`;
    return super.putRequest(url, {}, this.getRequestOptions());
  }

  updateGroup(id: string, newGroupId: string) {
    const url = `${this.baseUrl}/${id}/changeGroup`;
    return super.putRequest(url, { newGroupId }, this.getRequestOptions());
  }

  extend(licenseId: string, endDate: Date) {
    const url = `${this.baseUrl}/${licenseId}/extensions`;
    return super.postRequest(url, JSON.stringify({ endDate }), this.getRequestOptions());
  }

  updateLicensesBulk(data) {
    const url = `${this.baseUrl}`;
    return super.putRequest(url, data, this.getRequestOptions());
  }
}
